/** Quick Edit for a trip, opened on a Trip day (zero-based) when one is given — `?day=` is 1-based, as on the itinerary. */
export const quickEditPath = (tripId: string | number, dayIndex?: number): string =>
	`/trips/${tripId}/quick-edit${dayIndex === undefined ? '' : `?day=${dayIndex + 1}`}`

/** The itinerary on a Trip day: where Quick Edit leads back to. */
export const itineraryPath = (tripId: string | number, dayIndex: number): string =>
	`/trips/${tripId}/itinerary?day=${dayIndex + 1}`
